import Stack from '@mui/material/Stack';
import { PropsWithChildren } from 'react';

export default function AdminPageContent({
  children,
}: PropsWithChildren<unknown>) {
  return <Stack sx={{ marginX: 2, marginY: 1 }}>{children}</Stack>;
}
